import dataProvider from 'store/dataProvider';
import resources from 'common/constants/resources';
import { requestSaga } from 'common/utils/generators';
import { actionTypes } from '../reducer';

export function* getList() {
  yield requestSaga({
    actionType: actionTypes.getList,
    request: dataProvider.getList,
    resource: resources.procedure.escalated,
  });
}
